import { useContext } from "react";
import { MobileContext } from "./mobileContext";

export const useMobileContext = () => useContext(MobileContext);
